import React, { useMemo } from 'react'
import Header from 'pobble-components/dist/pobble-header'
import { useLocation } from 'react-router-dom'
import { useMe } from 'pobble-components/dist/pobble-user'
import { useSubscriptionDetails } from 'pobble-components/dist/subscriptions/utils'
import { FreeTrialButton } from './free-trial-button'
import { TrialDaysLeftButton } from './trial-days-left-button'

const LessonHeader = () => {
  const { pathname } = useLocation()
  const { me } = useMe()
  const {
    offerFreeTrial,
    isInPobbleSchool,
    hasAccessToTL,
    freeTrial,
    periodEnd,
    validPaymentMethod,
    cancelsAtTrialEnd
  } = useSubscriptionDetails()

  let preMenuSlot = null

  if (
    !!me &&
    !me?.account?.student_type &&
    offerFreeTrial &&
    (!hasAccessToTL && !isInPobbleSchool)
  ) {
    preMenuSlot = <FreeTrialButton />
  }

  if (
    !!me &&
    !me?.account?.student_type &&
    freeTrial &&
    !isInPobbleSchool &&
    cancelsAtTrialEnd
  ) {
    preMenuSlot = (
      <TrialDaysLeftButton
        periodEnd={periodEnd}
        validPaymentMethod={validPaymentMethod}
      />
    )
  }

  const isPreview = useMemo(
    () => {
      return (
        pathname.startsWith('/preview/') || pathname.startsWith('/teachers/')
      )
    },
    [pathname]
  )

  const isCalendar = useMemo(
    () => {
      return pathname.endsWith('/calendar')
    },
    [pathname]
  )

  const style = useMemo(
    () => {
      const calendar = isCalendar
        ? { position: 'sticky', top: 0, zIndex: 200 }
        : {}
      return { display: isPreview ? 'none' : 'flex', ...calendar }
    },
    [isPreview, isCalendar]
  )

  return (
    <Header
      preMenuSlot={preMenuSlot}
      activePage={pathname.startsWith('/works/') ? 'pobble-app' : 'prompts'}
      style={style}
    />
  )
}

export default LessonHeader
